/* ==========================================================================
 * Brand Casa — You May Also Like (PDP recommendations)
 * --------------------------------------------------------------------------
 * Runs on /products/* pages. Fetches Shopify's /recommendations/products.json
 * for the current product and injects a "You May Also Like" rail at the
 * bottom of the product section — works for both GemPages-built PDPs and
 * native Prestige PDPs (one code path, no template modifications).
 *
 * Config (window.__bcYMALConfig):
 *   - enabled (bool)
 *   - heading (string)
 *   - limit (int, 2-10)
 *
 * Data: reads product id from the existing ShopifyAnalytics payload or a
 * meta tag — does NOT modify product data. Pure rendering.
 * ========================================================================== */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;
  // Skip on the custom bc-pdp template — that section renders its own
  // YMAL rail matching the new design spec.
  if (document.querySelector('[data-bc-pdp]')) return;

  var cfg = window.__bcYMALConfig || {};
  if (cfg.enabled === false) return;
  var HEADING = cfg.heading || 'You may also like';
  var LIMIT = Math.min(Math.max(cfg.limit || 4, 2), 10);

  function getProductId() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product.id;
      }
    } catch (e) {}
    var m = (document.body.innerHTML.match(/"product_id":\s*(\d+)/) || [])[1];
    if (m) return parseInt(m, 10);
    return null;
  }

  function money(value) {
    if (value == null || value === '') return '';
    var num = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (!isFinite(num)) return '';
    var symbol = '£';
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD') symbol = '$';
    } catch (e) {}
    var formatted = num.toFixed(2).replace(/\.00$/, '');
    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/, ',');
    return symbol + formatted;
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(p) {
    var href = p.url || ('/products/' + p.handle);
    var img = p.featured_image || p.image;
    // featured_image may come as {url} or as a string — try both
    if (img && typeof img === 'object' && img.src) img = img.src;
    if (!img && p.media && p.media[0] && p.media[0].preview_image) img = p.media[0].preview_image.src;

    var price = p.price != null ? p.price : p.price_min;
    return (
      '<a class="bc-ymal__card" href="' + esc(href) + '">' +
      (img
        ? '<div class="bc-ymal__media"><img src="' + esc(img) + '" alt="" loading="lazy"></div>'
        : '<div class="bc-ymal__media bc-ymal__media--empty"></div>') +
      '<div class="bc-ymal__info">' +
      '<div class="bc-ymal__title">' + esc(p.title) + '</div>' +
      (price ? '<div class="bc-ymal__price">' + esc(money(price)) + '</div>' : '') +
      '</div>' +
      '</a>'
    );
  }

  function render(container, products) {
    if (!products || !products.length) return false;
    var html =
      '<section class="bc-ymal" aria-label="' + esc(HEADING) + '">' +
      '<h2 class="bc-ymal__heading">' + esc(HEADING) + '</h2>' +
      '<div class="bc-ymal__grid">' +
      products.slice(0, LIMIT).map(cardHTML).join('') +
      '</div>' +
      '</section>';
    container.insertAdjacentHTML('beforeend', html);
    return true;
  }

  function findAnchor() {
    // Prefer to append after the main product content
    return (
      document.querySelector('main') ||
      document.querySelector('.shopify-section-group-main-group') ||
      document.querySelector('#MainContent') ||
      document.body
    );
  }

  function init() {
    // Guard against double-injection
    if (document.querySelector('.bc-ymal')) return;

    var id = getProductId();
    if (!id) return;

    fetch('/recommendations/products.json?product_id=' + id + '&limit=' + LIMIT + '&intent=related', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        render(findAnchor(), data.products);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
